import type { EventDateRange } from '../../shared/types';
import { sortEventDates } from '../../shared/dates';
import { isValidDate } from '../../shared/validate';
import { registrationPath } from '../../shared/slug';
import { BASE_PATH } from '../../shared/types';

export function formatDate(iso: string, opts: Intl.DateTimeFormatOptions = { month: 'short', day: 'numeric', year: 'numeric' }): string {
  const [y, m, d] = iso.split('-').map(Number);
  return new Date(y, m - 1, d).toLocaleDateString(undefined, opts);
}

export function formatDates(dates: EventDateRange[]): string {
  const valid = sortEventDates(dates).filter((range) => isValidDate(range.start));
  if (!valid.length) return 'Dates not set';
  return valid
    .map((r) => (r.end && r.end !== r.start ? `${formatDate(r.start, { month: 'short', day: 'numeric' })} – ${formatDate(r.end)}` : formatDate(r.start)))
    .join(', ');
}

/** The full registration link, e.g. https://gatheredinforms.com/r/n7Qk2mP9vR4xT8wB/youth-conference-2026-10-30. */
export function registrationUrl(linkId: string, eventName: string, dates: EventDateRange[]): string {
  return `${location.origin}${BASE_PATH}/${registrationPath(linkId, eventName, dates)}`;
}
